export default "__VITE_ASSET__CvExoIib__"